import { apiBaseUrlPath } from '../../config'
import { Entity } from '../common/base/entity/entity'
import { collectionSchemas, entitySchema, methodSchemas } from './automation.schema'
import { AutomationAction } from './automationAction'

class AutomationEntity extends Entity {
	constructor(options) {
		super(options)
	}
}

let apiPath = ``
if (apiBaseUrlPath) {
	apiPath = `${apiBaseUrlPath}/AutomationConfig`
} else {
	apiPath = `AutomationConfig`
}

const fieldsMeta = {
	title: {
		label: 'Title',
		required: true,
		type: 'text',
		name: 'title',
		readOnlyOnEdit: true,
	},
	description: {
		label: 'Description',
		required: true,
		type: 'text',
		name: 'description',
		readOnlyOnEdit: true,
	},
	fromState: {
		label: 'Current State',
		required: true,
		type: 'select',
		api: {
			path: 'ticketing/AutomationConfig/getTicketStates',
			method: 'GET',
			//params: { filter: ['queueName'] },
			response: {
				ref: 'data',
				labelKey: 'name',
				valueKey: 'name',
			},
		},
		// options: [
		// 	{ label: 'Submitted', value: 'Submitted' },
		// 	{ label: 'Resolved', value: 'Resolved' },
		// ],
		name: 'fromState',
		readOnlyOnEdit: true,
	},
	// timer field
	days: {
		label: 'Days',
		required: true,
		// placeholder: '1M/1W/1H',
		type: 'text',
		name: 'days',
	},
	// cronPattern: {
	//     label: 'corn Pattern',
	//     required: true,
	//     type: 'text',
	//     name: 'cronPattern',
	//     readOnlyOnEdit: true
	// },
	// in: {
	//     label: 'in',
	//     required: true,
	//     type: 'number',
	//     name: 'in',
	//     readOnlyOnEdit: true
	// },
	// move to states
	moveToState: {
		label: 'Move to State',
		required: true,
		type: 'select',
		name: 'moveToState',
		options: [{ label: 'Closed', value: 'Closed' }],
		readOnlyOnEdit: true,
	},
	status: {
		label: 'Status',
		name: 'status',
		options: [
			{ label: 'UnPublished', value: 'UnPublished' },
			{ label: 'Published', value: 'Published' },
		],
		type: 'select',
		required: true,
	},
}

const actionsMeta = {
	editItem: {
		type: 'button',
		label: 'Update',
		action: 'upsertItem',
		name: 'editItem',
	},
	// cancel: {
	//     type: 'button',
	//     label: 'Cancel',
	//     action: 'cancelEdit',
	//     name: 'cancel'
	// },
	upsert: {
		label: 'Update',
		name: 'update',
		action: 'upsertItem',
		classes: 'fa fa-pencil fa-lg ',
		type: 'span',
	},
	// update: {
	//     label: 'Edit',
	//     name: 'update',
	//     action: 'updateItem',
	//     classes: 'fa fa-pencil fa-lg ',
	//     type: 'span'
	// },
	// list: {
	//     label: 'List All',
	//     name: 'list',
	//     action: 'load'
	// },
	// search: {
	//     label: 'Search',
	//     name: 'search',
	//     action: 'search'
	// },
	// view: {
	//     label: 'View',
	//     name: 'view',
	//     action: 'getItem',
	//     classes: 'fa fa-eye fa-lg',
	//     type: 'span'
	// },
	create:{
	    label: 'Create',
	    name : 'create',
	    type: 'button',
	    action: 'upsertItem',
	},
	createItem: {
		label: 'Update',
		action: 'upsertItem',
		name: 'create',
		type: 'button',
	},
	// deleteConfig:{
	//     label: 'Suppress',
	//     action: 'editItem',
	//     name : 'deleteConfig',
	//     color: 'danger',
	//     type: 'button',
	//     disabledEval: "profile.tenantUid !== item.tenantId"
	// }
}
const sectionsMeta = {
	section1: {
		title: 'Automation Details',
		items: [
			{ name: 'title', type: 'field' },
			{ name: 'description', type: 'field' },
		],
		classes: 'ticket-form',
	},
	section2: {
		// title: 'Automation Details',
		items: [{ name: 'fromState', type: 'field' }],
		classes: 'ticket-form',
	},
	section3: {
		// title: 'Automation Details',
		items: [{ name: 'days', type: 'field' }],
		// items:[{"name":"cronPattern", type:"field"}],
		classes: 'ticket-form',
	},
	// section4: {
	//     title: 'Automation Details',
	//     items:[{"name":"in", type:"field"}],
	//     classes:"ticket-form"
	// },
	section5: {
		title: 'Automation Details',
		items: [
			{ name: 'moveToState', type: 'field' },
			{ name: 'status', type: 'field' },
		],
		classes: 'ticket-form',
	},
	// finalSection1:{
	//     title: 'Automation Details',
	//     items:[{"name":"fromConfig", type: "field"},{"name":"toConfig", type: "field"},{"name":"ccConfig", type: "field"}],
	//     classes:"ticket-form"
	// },
	// finalSection2:{
	//     title: 'Automation Details',
	//     items:[{"name":"additionalTemplateConfig", type: "field"},{"name": "type", type: "field"}],
	//     classes:"ticket-form"
	// },
	// template: {
	//     title: 'Automation Details',
	//     items:[{"name":"Automation", type: "field"}],
	//     classes:"ticket-form"
	// },
	// headerComponent: {
	//     component: 'DetailHeader',
	// },
	automationTemplatesSection1: {
		cols: [8, 4],
		items: [
			{ name: 'section1', type: 'section', col: 1 },
			{ name: 'section2', type: 'section', col: 1 },
			{ name: 'section3', type: 'section', col: 1 },
		],
		classes: 'composite-inner-form',
	},
	// automationTemplatesSection2: {
	//     cols: [6,6],
	//     items:[

	//    {name: 'section4', type: 'section', col: 2}
	//     ],
	//     classes: 'composite-inner-form'
	// },
	automationTemplatesSection3: {
		cols: [8, 4],
		items: [
			{ name: 'section5', type: 'section', col: 1 },
			{ name: 'editItem', type: 'action', col: 1 },
		],
		classes: 'composite-inner-form',
	},
	automationTemplatesSection6: {
		cols: [8, 4],
		items: [
			{ name: 'section5', type: 'section', col: 1 },
			{ name: 'create', type: 'action', col: 1 },
		],
		classes: 'composite-inner-form',
	},
	// emailTemplatesForm: {
	//     cols: [6,6],
	//     items:[{name: 'basic1', type: 'section', col: 2},
	//     {name: 'createItem', type: 'action', col: 2}
	//     ],
	//     classes: 'composite-inner-form'
	// },
	// automationSection: {
	//     cols:[12],
	//     title: 'Automation Action',
	//     items:[{"name":"Automation", type: "section", col: 1}],
	//     classes: 'composite-inner-form'
	// },
	// emailTemplatesCreateForm: {
	//     cols: [6,6],
	//     items:[{name: 'section1', type: 'section', col: 1},
	//     {name: 'createItem', type: 'action', col: 2},
	//     {name: 'basic1', type: 'section', col: 2}
	//     ],
	//     classes: 'composite-inner-form'
	// },
	// automationEditForm: {
	//     cols: [6,6],
	//     items:[{name: 'basic1', type: 'section', col: 2},
	//     {name: 'deleteConfig', type: 'action', col: 2},
	//     {name: 'createItem', type: 'action', col: 2}
	//     ],
	//     classes: 'composite-inner-form'
	// }
}

const screens = {
	view: {
		items: [
			{ name: 'automationTemplatesSection1', type: 'section' },
			{ name: 'automationTemplatesSection2', type: 'section' },
			{ name: 'automationTemplatesSection3', type: 'section' },
		],
		// title: 'Automation Action'
	},
	create:{
	    items: [
				{name:'automationTemplatesSection1', type: 'section'},
				{name: 'automationTemplatesSection2', type: 'section'},
				{name: 'automationTemplatesSection6', type: 'section'},
				// {name: 'automationTemplatesFinalSection', type: 'section'}
			]
	},
	// edit:{
	//     items: [{name:'headerComponent', type: 'section'}, {name: 'automationEditForm', type: 'section'},{name: 'automationSection', type: 'section'}]
	// },
	list: {
		items: [
			{ name: 'title', type: 'link' },
			{ name: 'description', type: 'field' },
			{ name: 'status', type: 'field' },
		],
		filter: [
			{
				name: 'status',
				operator: 'ne',
				value: 'Deleted',
			},
			{
				name: 'status',
				operator: 'ne',
				value: '_Published',
			},
			{
				name: 'automationType',
				operator: 'ne',
				value: 'event',
			},
		],
		orderBy: ['createdAt desc'],
		multiselect: false,
	},
}
const Automation = new AutomationEntity({
	ActionClass: AutomationAction,
	fieldsMeta,
	actionsMeta,
	sectionsMeta,
	propFields: actionsMeta,
	tabsMeta: {},
	screens,
	name: 'Automation',
	title: 'Automation Action',
	idKey: 'id',
	methodSchemas,
	collectionSchemas,
	entitySchema,
	entityUrlPaths: { 
		update: `${apiPath}/update`, 
		default: apiPath, 
		publish: `${apiPath}/publish`, 
		getAll: `${apiPath}/findAndCountAllWithDefaultTenant`, 
		copyItem: `${apiPath}/copyItem`,
	},
	fetchDetailByApi: false,
})

const AutomationListSearchContainer = Automation.getContainer('ListSearch')
const AutomationCreateContainer = Automation.getContainer('Create')
const AutomationDetailContainer = Automation.getContainer('Detail')

export { AutomationListSearchContainer, AutomationDetailContainer, AutomationCreateContainer }

